const publicMetaImages = {
  "/blog/dscr-loan-interest-rates": "/dscr-loan-interest-rates.jpeg",
  "/tools/dscr-calculator": "/dscr-calculator.jpg",
  "/loans": "/min_loans_meta_image.jpeg",
  "/insurance": "/insurance.jpg",
};

export default publicMetaImages;
